import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Sparkles } from "lucide-react";
import api, { formatApiErrorDetail } from "@/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="admin-page" data-testid="admin-login-page">
      <div className="ambient-orb orb-one" />
      <div className="ambient-orb orb-two" />
      <motion.div className="admin-card" initial={{ opacity: 0, y: 26 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}>
        <div className="admin-mark"><Sparkles size={15} /> SITE STUDIO <Sparkles size={15} /></div>
        <h1 data-testid="admin-login-title">Behind the<br /><em>curtain.</em></h1>
        <p className="admin-sub" data-testid="admin-login-subtitle">Sign in to shape the celebration’s name, logo and favicon.</p>
        <form onSubmit={submit} className="admin-form">
          <label htmlFor="admin-email">EMAIL</label>
          <input id="admin-email" data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required autoFocus />
          <label htmlFor="admin-password">PASSWORD</label>
          <input id="admin-password" data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••••" required />
          <button type="submit" data-testid="admin-login-submit" disabled={busy}>
            <Lock size={13} /> {busy ? "Signing in…" : "Sign in"}
          </button>
          {error && <p className="admin-error" data-testid="admin-login-error">{error}</p>}
        </form>
        <a className="admin-back" href="/" data-testid="back-to-site-link">← back to the celebration</a>
      </motion.div>
    </main>
  );
}
